import i18n from "i18next";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import { Button, Link } from "@fluentui/react-components";
import { ShieldRegular } from "@fluentui/react-icons";
import Header from "../Header";

function PrivacyPolicy(props: any) {
  const privacyPolicyDe = (
    <div>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            <Button
              icon={<ShieldRegular fontSize={24} color="#ff6600" />}
              appearance="subtle"
            >
              {i18n.t<string>("privacy-policy").toLocaleUpperCase()}
            </Button>
          </StackShim>
        }
      />

      <div className="lueb-ContentBlock">
        <h2 style={{ color: "#ff6600" }}>1. Datenschutz auf einen Blick</h2>
        <div style={{ margin: "20px" }}></div>
        <h3>Allgemeine Hinweise</h3>{" "}
        <p>
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was
          mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website
          besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
          persönlich identifiziert werden können. Ausführliche Informationen zum
          Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten
          Datenschutzerklärung.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Datenerfassung auf dieser Website</h3>
        <div style={{ margin: "20px" }}></div>
        <h4>
          Wer ist verantwortlich für die Datenerfassung auf dieser Website?
        </h4>{" "}
        <p>
          Die Datenverarbeitung auf dieser Website erfolgt durch den
          Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt
          „Hinweis zur Verantwortlichen Stelle“ in dieser Datenschutzerklärung
          entnehmen.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h4>Wie erfassen wir Ihre Daten?</h4>{" "}
        <p>
          Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
          mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein
          Kontaktformular eingeben.
        </p>{" "}
        <p>
          Andere Daten werden automatisch oder nach Ihrer Einwilligung beim
          Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem
          technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit
          des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch,
          sobald Sie diese Website betreten.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h4>Wofür nutzen wir Ihre Daten?</h4>{" "}
        <p>
          Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung
          der Website zu gewährleisten. Andere Daten können zur Analyse Ihres
          Nutzerverhaltens verwendet werden. Sofern über die Website Verträge
          geschlossen oder angebahnt werden können, werden die übermittelten
          Daten auch für Vertragsangebote, Bestellungen oder sonstige
          Auftragsanfragen verarbeitet.
        </p>{" "}
        <div style={{ margin: "20px" }}></div>
        <h4>Welche Rechte haben Sie bezüglich Ihrer Daten?</h4>{" "}
        <p>
          Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft,
          Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu
          erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung
          dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur
          Datenverarbeitung erteilt haben, können Sie diese Einwilligung
          jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht,
          unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer
          personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein
          Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
        </p>{" "}
        <p>
          Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich
          jederzeit an uns wenden.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h2 style={{ color: "#ff6600" }}>2. Hosting</h2>
        <p>Wir hosten die Inhalte unserer Website bei folgendem Anbieter:</p>
        <h3>Amazon Web Services (AWS)</h3>{" "}
        <p>
          Anbieter ist die Amazon Web Services EMEA SARL, 38 Avenue John F.
          Kennedy, 1855 Luxemburg (nachfolgend AWS).
        </p>{" "}
        <p>
          Wenn Sie unsere Website besuchen, werden Ihre personenbezogenen Daten
          auf den Servern von AWS verarbeitet. Hierbei können auch
          personenbezogene Daten an das Mutterunternehmen von AWS in die USA
          übermittelt werden. Die Datenübertragung in die USA wird auf die
          EU-Standardvertragsklauseln gestützt. Details finden Sie hier:{" "}
          <Link
            href="https://aws.amazon.com/de/blogs/security/aws-gdpr-data-processing-addendum/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://aws.amazon.com/de/blogs/security/aws-gdpr-data-processing-addendum/
          </Link>
          .
        </p>{" "}
        <div style={{ margin: "1px" }}></div>
        <p>
          Weitere Informationen entnehmen Sie der Datenschutzerklärung von AWS:{" "}
          <Link
            href="https://aws.amazon.com/de/privacy/?nc1=f_pr"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://aws.amazon.com/de/privacy/?nc1=f_pr
          </Link>
          .<div style={{ margin: "1px" }}></div>
        </p>{" "}
        <p>
          Die Verwendung von AWS erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f
          DSGVO. Wir haben ein berechtigtes Interesse an einer möglichst
          zuverlässigen Darstellung unserer Website. Sofern eine entsprechende
          Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich
          auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG,
          soweit die Einwilligung die Speicherung von Cookies oder den Zugriff
          auf Informationen im Endgerät des Nutzers (z. B.
          Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung
          ist jederzeit widerrufbar.
        </p>
        <p>
          Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US Data
          Privacy Framework“ (DPF). Der DPF ist ein Übereinkommen zwischen der
          Europäischen Union und den USA, der die Einhaltung europäischer
          Datenschutzstandards bei Datenverarbeitungen in den USA gewährleisten
          soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich,
          diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu
          erhalten Sie vom Anbieter unter folgendem Link:
          <Link
            href="https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000TOWQAA4&status=Active"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000TOWQAA4&status=Active
          </Link>
          .
        </p>
        <div style={{ margin: "20px" }}></div>
        <h4>Auftragsverarbeitung</h4>{" "}
        <p>
          Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung
          des oben genannten Dienstes geschlossen. Hierbei handelt es sich um
          einen datenschutzrechtlich vorgeschriebenen Vertrag, der
          gewährleistet, dass dieser die personenbezogenen Daten unserer
          Websitebesucher nur nach unseren Weisungen und unter Einhaltung der
          DSGVO verarbeitet.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h2 style={{ color: "#ff6600" }}>
          3. Allgemeine Hinweise und Pflichtinformationen
        </h2>
        <div style={{ margin: "20px" }}></div>
        <h3>Datenschutz</h3>{" "}
        <p>
          Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten
          sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und
          entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser
          Datenschutzerklärung.
        </p>{" "}
        <p>
          Wenn Sie diese Website benutzen, werden verschiedene personenbezogene
          Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie
          persönlich identifiziert werden können. Die vorliegende
          Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir
          sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das
          geschieht.
        </p>{" "}
        <p>
          Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei
          der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein
          lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht
          möglich.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Hinweis zur verantwortlichen Stelle</h3>{" "}
        <p>
          Die verantwortliche Stelle für die Datenverarbeitung auf dieser
          Website ist:
        </p>
        <div style={{ margin: "4px" }}></div>
        <p>
          Johannes Lübbering GmbH
          <br />
          Industriestraße 4<br />
          33442 Herzebrock-Clarholz
        </p>
        <p>
          <br />
          Telefon: +49 (0) 5245 8309-0
          <br />
          E-Mail: info@luebbering.de
        </p>
        <div style={{ margin: "4px" }}></div>
        <p>
          Verantwortliche Stelle ist die natürliche oder juristische Person, die
          allein oder gemeinsam mit anderen über die Zwecke und Mittel der
          Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen
          o. Ä.) entscheidet.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Speicherdauer</h3>{" "}
        <p>
          Soweit innerhalb dieser Datenschutzerklärung keine speziellere
          Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten
          bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie
          ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung
          zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern
          wir keine anderen rechtlich zulässigen Gründe für die Speicherung
          Ihrer personenbezogenen Daten haben (z.B. steuer- oder
          handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall
          erfolgt die Löschung nach Fortfall dieser Gründe.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>
          Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf
          dieser Website
        </h3>{" "}
        <p>
          Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten
          wir Ihre personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit.
          a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere
          Datenkategorien nach Art. 9 Abs. 1 DSGVO verarbeitet werden. Im Falle
          einer ausdrücklichen Einwilligung in die Übertragung personenbezogener
          Daten in Drittstaaten erfolgt die Datenverarbeitung außerdem auf
          Grundlage von Art. 49 Abs. 1 lit. a DSGVO. Sofern Sie in die
          Speicherung von Cookies oder in den Zugriff auf Informationen in Ihr
          Endgerät (z. B. via Device-Fingerprinting) eingewilligt haben, erfolgt
          die Datenverarbeitung zusätzlich auf Grundlage von § 25 Abs. 1 TDDDG.
          Die Einwilligung ist jederzeit widerrufbar. Sind Ihre Daten zur
          Vertragserfüllung oder zur Durchführung vorvertraglicher Maßnahmen
          erforderlich, verarbeiten wir Ihre Daten auf Grundlage des Art. 6 Abs.
          1 lit. b DSGVO. Des Weiteren verarbeiten wir Ihre Daten, sofern diese
          zur Erfüllung einer rechtlichen Verpflichtung erforderlich sind auf
          Grundlage von Art. 6 Abs. 1 lit. c DSGVO. Die Datenverarbeitung kann
          ferner auf Grundlage unseres berechtigten Interesses nach Art. 6 Abs.
          1 lit. f DSGVO erfolgen. Über die jeweils im Einzelfall einschlägigen
          Rechtsgrundlagen wird in den folgenden Absätzen dieser
          Datenschutzerklärung informiert.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Datenschutzbeauftragter</h3>{" "}
        <p>Wir haben einen Datenschutzbeauftragten benannt.</p>
        <div style={{ margin: "4px" }}></div>
        <p>
          bits + bytes it-solutions GmbH & Co. KG
          <br />
          Krombacher Straße 24
          <br />
          57223 Kreuztal
        </p>
        <div style={{ margin: "1px" }}></div>
        <p>
          Telefon: +49 (0700) 20 30 10 30
          <br />
          E-Mail: datenschutz@bits-bytes.de
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Empfänger von personenbezogenen Daten</h3>{" "}
        <p>
          Im Rahmen unserer Geschäftstätigkeit arbeiten wir mit verschiedenen
          externen Stellen zusammen. Dabei ist teilweise auch eine Übermittlung
          von personenbezogenen Daten an diese externen Stellen erforderlich.
          Wir geben personenbezogene Daten nur dann an externe Stellen weiter,
          wenn dies im Rahmen einer Vertragserfüllung erforderlich ist, wenn wir
          gesetzlich hierzu verpflichtet sind (z. B. Weitergabe von Daten an
          Steuerbehörden), wenn wir ein berechtigtes Interesse nach Art. 6 Abs.
          1 lit. f DSGVO an der Weitergabe haben oder wenn eine sonstige
          Rechtsgrundlage die Datenweitergabe erlaubt. Beim Einsatz von
          Auftragsverarbeitern geben wir personenbezogene Daten unserer Kunden
          nur auf Grundlage eines gültigen Vertrags über Auftragsverarbeitung
          weiter. Im Falle einer gemeinsamen Verarbeitung wird ein Vertrag über
          gemeinsame Verarbeitung geschlossen.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>{" "}
        <p>
          Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen
          Einwilligung möglich. Sie können eine bereits erteilte Einwilligung
          jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf
          erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>
          Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie
          gegen Direktwerbung (Art. 21 DSGVO)
        </h3>{" "}
        <p>
          WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER
          F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH
          AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER
          PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN
          AUF DIESE BESTIMMUNGEN GESTÜTZTES PROFILING. DIE JEWEILIGE
          RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT, ENTNEHMEN SIE
          DIESER DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH EINLEGEN, WERDEN WIR
          IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES
          SEI DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE
          VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN
          ÜBERWIEGEN ODER DIE VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG
          ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21 ABS.
          1 DSGVO).
        </p>
        <p>
          WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU
          BETREIBEN, SO HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE
          VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE
          DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH FÜR DAS PROFILING,
          SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT. WENN SIE
          WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN ANSCHLIESSEND NICHT
          MEHR ZUM ZWECKE DER DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH ART. 21
          ABS. 2 DSGVO).
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h3>{" "}
        <p>
          Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein
          Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem
          Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes
          oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht
          besteht unbeschadet anderweitiger verwaltungsrechtlicher oder
          gerichtlicher Rechtsbehelfe.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Recht auf Datenübertragbarkeit</h3>{" "}
        <p>
          Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung
          oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich
          oder an einen Dritten in einem gängigen, maschinenlesbaren Format
          aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an
          einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es
          technisch machbar ist.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Auskunft, Berichtigung und Löschung</h3>{" "}
        <p>
          Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit
          das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
          personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck
          der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder
          Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema
          personenbezogene Daten können Sie sich jederzeit an uns wenden.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Recht auf Einschränkung der Verarbeitung</h3>{" "}
        <p>
          Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer
          personenbezogenen Daten zu verlangen. Hierzu können Sie sich jederzeit
          an uns wenden. Das Recht auf Einschränkung der Verarbeitung besteht in
          folgenden Fällen:
        </p>{" "}
        <ul>
          {" "}
          <li>
            Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten
            personenbezogenen Daten bestreiten, benötigen wir in der Regel Zeit,
            um dies zu überprüfen. Für die Dauer der Prüfung haben Sie das
            Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen
            Daten zu verlangen.
          </li>{" "}
          <li>
            Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig
            geschah/geschieht, können Sie statt der Löschung die Einschränkung
            der Datenverarbeitung verlangen.
          </li>{" "}
          <li>
            Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie
            jedoch zur Ausübung, Verteidigung oder Geltendmachung von
            Rechtsansprüchen benötigen, haben Sie das Recht, statt der Löschung
            die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu
            verlangen.
          </li>{" "}
          <li>
            Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt
            haben, muss eine Abwägung zwischen Ihren und unseren Interessen
            vorgenommen werden. Solange noch nicht feststeht, wessen Interessen
            überwiegen, haben Sie das Recht, die Einschränkung der Verarbeitung
            Ihrer personenbezogenen Daten zu verlangen.
          </li>{" "}
        </ul>{" "}
        <p>
          Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt
          haben, dürfen diese Daten – von ihrer Speicherung abgesehen – nur mit
          Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder Verteidigung
          von Rechtsansprüchen oder zum Schutz der Rechte einer anderen
          natürlichen oder juristischen Person oder aus Gründen eines wichtigen
          öffentlichen Interesses der Europäischen Union oder eines
          Mitgliedstaats verarbeitet werden.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>SSL- bzw. TLS-Verschlüsselung</h3>{" "}
        <p>
          Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
          Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder
          Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw.
          TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie
          daran, dass die Adresszeile des Browsers von „http://“ auf „https://“
          wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
        </p>{" "}
        <p>
          Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die
          Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen
          werden.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Widerspruch gegen Werbe-E-Mails</h3>{" "}
        <p>
          Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten
          Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter
          Werbung und Informationsmaterialien wird hiermit widersprochen. Die
          Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im
          Falle der unverlangten Zusendung von Werbeinformationen, etwa durch
          Spam-E-Mails, vor.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h2 style={{ color: "#ff6600" }}>
          4. Datenerfassung auf dieser Website
        </h2>
        <h3>Cookies</h3>{" "}
        <p>
          Unsere Internetseiten verwenden so genannte „Cookies“. Cookies sind
          kleine Datenpakete und richten auf Ihrem Endgerät keinen Schaden an.
          Sie werden entweder vorübergehend für die Dauer einer Sitzung
          (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem
          Endgerät gespeichert. Session-Cookies werden nach Ende Ihres Besuchs
          automatisch gelöscht. Permanente Cookies bleiben auf Ihrem Endgerät
          gespeichert, bis Sie diese selbst löschen oder eine automatische
          Löschung durch Ihren Webbrowser erfolgt.
        </p>
        <p>
          Cookies können von uns (First-Party-Cookies) oder von Drittunternehmen
          stammen (sog. Third-Party-Cookies). Third-Party-Cookies ermöglichen
          die Einbindung bestimmter Dienstleistungen von Drittunternehmen
          innerhalb von Webseiten (z. B. Cookies zur Abwicklung von
          Zahlungsdienstleistungen).
        </p>
        <p>
          Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind
          technisch notwendig, da bestimmte Webseitenfunktionen ohne diese nicht
          funktionieren würden (z. B. die Warenkorbfunktion oder die Anzeige von
          Videos). Andere Cookies können zur Auswertung des Nutzerverhaltens
          oder zu Werbezwecken verwendet werden.
        </p>
        <p>
          Cookies, die zur Durchführung des elektronischen
          Kommunikationsvorgangs, zur Bereitstellung bestimmter, von Ihnen
          erwünschter Funktionen (z. B. für die Warenkorbfunktion) oder zur
          Optimierung der Website (z. B. Cookies zur Messung des Webpublikums)
          erforderlich sind (notwendige Cookies), werden auf Grundlage von Art.
          6 Abs. 1 lit. f DSGVO gespeichert, sofern keine andere Rechtsgrundlage
          angegeben wird. Der Websitebetreiber hat ein berechtigtes Interesse an
          der Speicherung von notwendigen Cookies zur technisch fehlerfreien und
          optimierten Bereitstellung seiner Dienste. Sofern eine Einwilligung
          zur Speicherung von Cookies und vergleichbaren
          Wiedererkennungstechnologien abgefragt wurde, erfolgt die Verarbeitung
          ausschließlich auf Grundlage dieser Einwilligung (Art. 6 Abs. 1 lit. a
          DSGVO und § 25 Abs. 1 TDDDG); die Einwilligung ist jederzeit
          widerrufbar.
        </p>
        <p>
          Sie können Ihren Browser so einstellen, dass Sie über das Setzen von
          Cookies informiert werden und Cookies nur im Einzelfall erlauben, die
          Annahme von Cookies für bestimmte Fälle oder generell ausschließen
          sowie das automatische Löschen der Cookies beim Schließen des Browsers
          aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität
          dieser Website eingeschränkt sein.
        </p>
        <p>
          Welche Cookies und Dienste auf dieser Website eingesetzt werden,
          können Sie dieser Datenschutzerklärung entnehmen.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Server-Log-Dateien</h3>
        <p>
          Der Provider der Seiten erhebt und speichert automatisch Informationen
          in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns
          übermittelt. Dies sind:
        </p>
        <div style={{ margin: "5px" }}></div>
        <ul>
          {" "}
          <li>Browsertyp und Browserversion</li>{" "}
          <li>verwendetes Betriebssystem</li> <li>Referrer URL</li>{" "}
          <li>Hostname des zugreifenden Rechners</li>{" "}
          <li>Uhrzeit der Serveranfrage</li> <li>IP-Adresse</li>{" "}
        </ul>{" "}
        <p>
          Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht
          vorgenommen.
        </p>{" "}
        <p>
          Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1
          lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an
          der technisch fehlerfreien Darstellung und der Optimierung seiner
          Website – hierzu müssen die Server-Log-Files erfasst werden.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Kontaktformular</h3>{" "}
        <p>
          Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre
          Angaben aus dem Anfrageformular inklusive der von Ihnen dort
          angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den
          Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir
          nicht ohne Ihre Einwilligung weiter.
        </p>{" "}
        <p>
          Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1
          lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags
          zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen
          erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf
          unserem berechtigten Interesse an der effektiven Bearbeitung der an
          uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
          Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt
          wurde; die Einwilligung ist jederzeit widerrufbar.
        </p>{" "}
        <p>
          Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei
          uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur
          Speicherung widerrufen oder der Zweck für die Datenspeicherung
          entfällt (z. B. nach abgeschlossener Bearbeitung Ihrer Anfrage).
          Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen
          – bleiben unberührt.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Anfrage per E-Mail, Telefon oder Telefax</h3>{" "}
        <p>
          Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre
          Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten
          (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns
          gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre
          Einwilligung weiter.
        </p>{" "}
        <p>
          Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1
          lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags
          zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen
          erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf
          unserem berechtigten Interesse an der effektiven Bearbeitung der an
          uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
          Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt
          wurde; die Einwilligung ist jederzeit widerrufbar.
        </p>{" "}
        <p>
          Die von Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben
          bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur
          Speicherung widerrufen oder der Zweck für die Datenspeicherung
          entfällt (z. B. nach abgeschlossener Bearbeitung Ihres Anliegens).
          Zwingende gesetzliche Bestimmungen – insbesondere gesetzliche
          Aufbewahrungsfristen – bleiben unberührt.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Registrierung auf dieser Website</h3>{" "}
        <p>
          Sie können sich auf dieser Website registrieren, um zusätzliche
          Funktionen auf der Seite zu nutzen. Die dazu eingegebenen Daten
          verwenden wir nur zum Zwecke der Nutzung des jeweiligen Angebotes oder
          Dienstes, für den Sie sich registriert haben. Die bei der
          Registrierung abgefragten Pflichtangaben müssen vollständig angegeben
          werden. Anderenfalls werden wir die Registrierung ablehnen.
        </p>{" "}
        <p>
          Für wichtige Änderungen etwa beim Angebotsumfang oder bei technisch
          notwendigen Änderungen nutzen wir die bei der Registrierung angegebene
          E-Mail-Adresse, um Sie auf diesem Wege zu informieren.
        </p>{" "}
        <p>
          Die Verarbeitung der bei der Registrierung eingegebenen Daten erfolgt
          zum Zwecke der Durchführung des durch die Registrierung begründeten
          Nutzungsverhältnisses und ggf. zur Anbahnung weiterer Verträge (Art. 6
          Abs. 1 lit. b DSGVO).
        </p>{" "}
        <p>
          Die bei der Registrierung erfassten Daten werden von uns gespeichert,
          solange Sie auf dieser Website registriert sind und werden
          anschließend gelöscht. Gesetzliche Aufbewahrungsfristen bleiben
          unberührt.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h2 style={{ color: "#ff6600" }}>5. Newsletter</h2>
        <h3>Newsletter­daten</h3>{" "}
        <p>
          Wenn Sie den auf der Website angebotenen Newsletter beziehen möchten,
          benötigen wir von Ihnen eine E-Mail-Adresse sowie Informationen,
          welche uns die Überprüfung gestatten, dass Sie der Inhaber der
          angegebenen E-Mail-Adresse sind und mit dem Empfang des Newsletters
          einverstanden sind. Weitere Daten werden nicht bzw. nur auf
          freiwilliger Basis erhoben. Diese Daten verwenden wir ausschließlich
          für den Versand der angeforderten Informationen und geben diese nicht
          an Dritte weiter.
        </p>{" "}
        <p>
          Die Verarbeitung der in das Newsletteranmeldeformular eingegebenen
          Daten erfolgt ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6
          Abs. 1 lit. a DSGVO). Die erteilte Einwilligung zur Speicherung der
          Daten, der E-Mail-Adresse sowie deren Nutzung zum Versand des
          Newsletters können Sie jederzeit widerrufen, etwa über den
          „Austragen“-Link im Newsletter. Die Rechtmäßigkeit der bereits
          erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.
        </p>{" "}
        <p>
          Die von Ihnen zum Zwecke des Newsletter-Bezugs bei uns hinterlegten
          Daten werden von uns bis zu Ihrer Austragung aus dem Newsletter bei
          uns bzw. dem Newsletterdiensteanbieter gespeichert und nach der
          Abbestellung des Newsletters oder nach Zweckfortfall aus der
          Newsletterverteilerliste gelöscht. Wir behalten uns vor,
          E-Mail-Adressen aus unserem Newsletterverteiler nach eigenem Ermessen
          im Rahmen unseres berechtigten Interesses nach Art. 6 Abs. 1 lit. f
          DSGVO zu löschen oder zu sperren.
        </p>{" "}
        <p>
          Daten, die zu anderen Zwecken bei uns gespeichert wurden, bleiben
          hiervon unberührt.
        </p>{" "}
        <p>
          Nach Ihrer Austragung aus der Newsletterverteilerliste wird Ihre
          E-Mail-Adresse bei uns bzw. dem Newsletterdiensteanbieter ggf. in
          einer Blacklist gespeichert, sofern dies zur Verhinderung künftiger
          Mailings erforderlich ist. Die Daten aus der Blacklist werden nur für
          diesen Zweck verwendet und nicht mit anderen Daten zusammengeführt.
          Dies dient sowohl Ihrem Interesse als auch unserem Interesse an der
          Einhaltung der gesetzlichen Vorgaben beim Versand von Newslettern
          (berechtigtes Interesse im Sinne des Art. 6 Abs. 1 lit. f DSGVO). Die
          Speicherung in der Blacklist ist zeitlich nicht befristet.{" "}
          <div style={{ margin: "5px" }}></div>
          <strong>
            Sie können der Speicherung widersprechen, sofern Ihre Interessen
            unser berechtigtes Interesse überwiegen.
          </strong>
        </p>
        <div style={{ margin: "20px" }}></div>
        <h2 style={{ color: "#ff6600" }}>6. eCommerce und Zahlungsanbieter</h2>
        <h3>Verarbeiten von Kunden- und Vertragsdaten</h3>{" "}
        <p>
          Wir erheben, verarbeiten und nutzen personenbezogene Kunden- und
          Vertragsdaten zur Begründung, inhaltlichen Ausgestaltung und Änderung
          unserer Vertragsbeziehungen. Personenbezogene Daten über die
          Inanspruchnahme dieser Website (Nutzungsdaten) erheben, verarbeiten
          und nutzen wir nur, soweit dies erforderlich ist, um dem Nutzer die
          Inanspruchnahme des Dienstes zu ermöglichen oder abzurechnen.
          Rechtsgrundlage hierfür ist Art. 6 Abs. 1 lit. b DSGVO.
        </p>{" "}
        <p>
          Die erhobenen Kundendaten werden nach Abschluss des Auftrags oder
          Beendigung der Geschäftsbeziehung und Ablauf der ggf. bestehenden
          gesetzlichen Aufbewahrungsfristen gelöscht. Gesetzliche
          Aufbewahrungsfristen bleiben unberührt.
        </p>
      </div>
    </div>
  );

  const privacyPolicyEn = (
    <div>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            <Button
              icon={<ShieldRegular fontSize={24} color="#ff6600" />}
              appearance="subtle"
            >
              {i18n.t<string>("privacy-policy").toLocaleUpperCase()}
            </Button>
          </StackShim>
        }
      />

      <div className="lueb-ContentBlock">
        <h2 style={{ color: "#ff6600" }}>1. An overview of data protection</h2>
        <div style={{ margin: "20px" }}></div>
        <h3>General information</h3>{" "}
        <p>
          The following information will provide you with an easy to navigate
          overview of what will happen with your personal data when you visit
          this website. The term “personal data” comprises all data that can be
          used to personally identify you. For detailed information about the
          subject matter of data protection, please consult our Data Protection
          Declaration, which we have included beneath this copy.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Data recording on this website</h3>{" "}
        <div style={{ margin: "20px" }}></div>
        <h4>
          Who is the responsible party for the recording of data on this website
          (i.e., the “controller”)?
        </h4>{" "}
        <p>
          The data on this website is processed by the operator of the website,
          whose contact information is available under section “Information
          about the responsible party (referred to as the “controller” in the
          GDPR)” in this Privacy Policy.
        </p>{" "}
        <div style={{ margin: "20px" }}></div>
        <h4>How do we record your data?</h4>{" "}
        <p>
          We collect your data as a result of your sharing of your data with us.
          This may, for instance be information you enter into our contact form.
        </p>{" "}
        <p>
          Other data shall be recorded by our IT systems automatically or after
          you consent to its recording during your website visit. This data
          comprises primarily technical information (e.g., web browser,
          operating system, or time the site was accessed). This information is
          recorded automatically when you access this website.
        </p>{" "}
        <div style={{ margin: "20px" }}></div>
        <h4>What are the purposes we use your data for?</h4>{" "}
        <p>
          A portion of the information is generated to guarantee the error free
          provision of the website. Other data may be used to analyze your user
          patterns.
        </p>{" "}
        <div style={{ margin: "20px" }}></div>
        <h4>
          What rights do you have as far as your information is concerned?
        </h4>{" "}
        <p>
          You have the right to receive information about the source,
          recipients, and purposes of your archived personal data at any time
          without having to pay a fee for such disclosures. You also have the
          right to demand that your data are rectified or eradicated. If you
          have consented to data processing, you have the option to revoke this
          consent at any time, which shall affect all future data processing.
          Moreover, you have the right to demand that the processing of your
          data be restricted under certain circumstances. Furthermore, you have
          the right to log a complaint with the competent supervising agency.
        </p>{" "}
        <p>
          Please do not hesitate to contact us at any time if you have questions
          about this or any other data protection related issues.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h2 style={{ color: "#ff6600" }}>2. Hosting</h2>
        <p>
          We are hosting the content of our website at the following provider
        </p>
        <h3>Amazon Web Services (AWS)</h3>{" "}
        <p>
          The provider is Amazon Web Services EMEA SARL, 38 Avenue John F.
          Kennedy, 1855 Luxembourg (hereinafter referred to as “AWS”).
        </p>{" "}
        <p>
          When you visit our website, your personal data will be processed on
          AWS servers. This may also result in the transfer of personal data to
          the parent company of AWS in the United States. The transfer of data
          to the US is based on the EU’s standard contractual clauses. For
          details please consult:{" "}
          <Link
            href="https://aws.amazon.com/de/blogs/security/aws-gdpr-data-processing-addendum/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://aws.amazon.com/de/blogs/security/aws-gdpr-data-processing-addendum/
          </Link>
          .
        </p>{" "}
        <p>
          For more information, please see the AWS Data Privacy Policy:{" "}
          <Link
            href="https://aws.amazon.com/de/privacy/?nc1=f_pr"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://aws.amazon.com/de/privacy/?nc1=f_pr
          </Link>
          .
        </p>{" "}
        <p>
          AWS is used on the basis of Art. 6(1)(f) GDPR. We have a legitimate
          interest in a depiction of our website that is as reliable as
          possible. If appropriate consent has been obtained, the processing is
          carried out exclusively on the basis of Art. 6(1)(a) GDPR and § 25 (1)
          TDDDG, insofar the consent includes the storage of cookies or the
          access to information in the user’s end device (e.g., device
          fingerprinting) within the meaning of the TDDDG. This consent can be
          revoked at any time.
        </p>
        <p>
          The company is certified in accordance with the “EU-US Data Privacy
          Framework” (DPF). The DPF is an agreement between the European Union
          and the US, which is intended to ensure compliance with European data
          protection standards for data processing in the US. Every company
          certified under the DPF is obliged to comply with these data
          protection standards. For more information, please contact the
          provider under the following link:{""}
          <Link
            href="https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000TOWQAA4&status=Activ"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000TOWQAA4&status=Activ
          </Link>
        </p>
        <div style={{ margin: "20px" }}></div>
        <h4>Data processing</h4>{" "}
        <p>
          We have concluded a data processing agreement (DPA) with the
          above-mentioned provider. This is a contract mandated by data privacy
          laws that guarantees that they process personal data of our website
          visitors only based on our instructions and in compliance with the
          GDPR.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h2 style={{ color: "#ff6600" }}>
          3. General information and mandatory information
        </h2>
        <h3>Data protection</h3>{" "}
        <p>
          The operators of this website and its pages take the protection of
          your personal data very seriously. Hence, we handle your personal data
          as confidential information and in compliance with the statutory data
          protection regulations and this Data Protection Declaration.
        </p>{" "}
        <p>
          Whenever you use this website, a variety of personal information will
          be collected. Personal data comprises data that can be used to
          personally identify you. This Data Protection Declaration explains
          which data we collect as well as the purposes we use this data for. It
          also explains how, and for which purpose the information is collected.
        </p>{" "}
        <p>
          We herewith advise you that the transmission of data via the Internet
          (i.e., through e-mail communications) may be prone to security gaps.
          It is not possible to completely protect data against third-party
          access.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>
          Information about the responsible party (referred to as the
          “controller” in the GDPR)
        </h3>{" "}
        <p>The data processing controller on this website is:</p>{" "}
        <div style={{ margin: "4px" }}></div>
        <p>
          Johannes Lübbering GmbH
          <br />
          Industriestraße 4<br />
          33442 Herzebrock-Clarholz
        </p>
        <p>
          <br />
          Phone: +49 (0) 5245 8309-0
          <br />
          E-mail: info@luebbering.de
        </p>
        <div style={{ margin: "4px" }}></div>
        <p>
          The controller is the natural person or legal entity that
          single-handedly or jointly with others makes decisions as to the
          purposes of and resources for the processing of personal data (e.g.,
          names, e-mail addresses, etc.).
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Storage duration</h3>{" "}
        <p>
          Unless a more specific storage period has been specified in this
          privacy policy, your personal data will remain with us until the
          purpose for which it was collected no longer applies. If you assert a
          justified request for deletion or revoke your consent to data
          processing, your data will be deleted, unless we have other legally
          permissible reasons for storing your personal data (e.g., tax or
          commercial law retention periods); in the latter case, the deletion
          will take place after these reasons cease to apply.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>
          General information on the legal basis for the data processing on this
          website
        </h3>{" "}
        <p>
          If you have consented to data processing, we process your personal
          data on the basis of Art. 6(1)(a) GDPR or Art. 9 (2)(a) GDPR, if
          special categories of data are processed according to Art. 9 (1)
          DSGVO. In the case of explicit consent to the transfer of personal
          data to third countries, the data processing is also based on Art. 49
          (1)(a) GDPR. If you have consented to the storage of cookies or to the
          access to information in your end device (e.g., via device
          fingerprinting), the data processing is additionally based on § 25 (1)
          TDDDG. The consent can be revoked at any time. If your data is
          required for the fulfillment of a contract or for the implementation
          of pre-contractual measures, we process your data on the basis of Art.
          6(1)(b) GDPR. Furthermore, if your data is required for the
          fulfillment of a legal obligation, we process it on the basis of Art.
          6(1)(c) GDPR. Furthermore, the data processing may be carried out on
          the basis of our legitimate interest according to Art. 6(1)(f) GDPR.
          Information on the relevant legal basis in each individual case is
          provided in the following paragraphs of this privacy policy.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Designation of a data protection officer</h3>{" "}
        <p>We have appointed a data protection officer.</p>
        <div style={{ margin: "4px" }}></div>
        <p>
          bits + bytes it-solutions GmbH & Co. KG
          <br />
          Krombacher Straße 24
          <br />
          57223 Kreuztal
        </p>
        <p>
          <br />
          Phone: +49 (0700) 20 30 10 30
          <br />
          E-mail: datenschutz@bits-bytes.de
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Recipients of personal data</h3>{" "}
        <p>
          In the scope of our business activities, we cooperate with various
          external parties. In some cases, this also requires the transfer of
          personal data to these external parties. We only disclose personal
          data to external parties if this is required as part of the
          fulfillment of a contract, if we are legally obligated to do so (e.g.,
          disclosure of data to tax authorities), if we have a legitimate
          interest in the disclosure pursuant to Art. 6 (1)(f) GDPR, or if
          another legal basis permits the disclosure of this data. When using
          processors, we only disclose personal data of our customers on the
          basis of a valid contract on data processing. In the case of joint
          processing, a joint processing agreement is concluded.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Revocation of your consent to the processing of data</h3>{" "}
        <p>
          A wide range of data processing transactions are possible only subject
          to your express consent. You can also revoke at any time any consent
          you have already given us. This shall be without prejudice to the
          lawfulness of any data collection that occurred prior to your
          revocation.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>
          Right to object to the collection of data in special cases; right to
          object to direct advertising (Art. 21 GDPR)
        </h3>{" "}
        <p>
          IN THE EVENT THAT DATA ARE PROCESSED ON THE BASIS OF ART. 6(1)(E) OR
          (F) GDPR, YOU HAVE THE RIGHT TO AT ANY TIME OBJECT TO THE PROCESSING
          OF YOUR PERSONAL DATA BASED ON GROUNDS ARISING FROM YOUR UNIQUE
          SITUATION. THIS ALSO APPLIES TO ANY PROFILING BASED ON THESE
          PROVISIONS. TO DETERMINE THE LEGAL BASIS, ON WHICH ANY PROCESSING OF
          DATA IS BASED, PLEASE CONSULT THIS DATA PROTECTION DECLARATION. IF YOU
          LOG AN OBJECTION, WE WILL NO LONGER PROCESS YOUR AFFECTED PERSONAL
          DATA, UNLESS WE ARE IN A POSITION TO PRESENT COMPELLING PROTECTION
          WORTHY GROUNDS FOR THE PROCESSING OF YOUR DATA, THAT OUTWEIGH YOUR
          INTERESTS, RIGHTS AND FREEDOMS OR IF THE PURPOSE OF THE PROCESSING IS
          THE CLAIMING, EXERCISING OR DEFENCE OF LEGAL ENTITLEMENTS (OBJECTION
          PURSUANT TO ART. 21(1) GDPR).
        </p>{" "}
        <p>
          IF YOUR PERSONAL DATA IS BEING PROCESSED IN ORDER TO ENGAGE IN DIRECT
          ADVERTISING, YOU HAVE THE RIGHT TO OBJECT TO THE PROCESSING OF YOUR
          AFFECTED PERSONAL DATA FOR THE PURPOSES OF SUCH ADVERTISING AT ANY
          TIME. THIS ALSO APPLIES TO PROFILING TO THE EXTENT THAT IT IS
          AFFILIATED WITH SUCH DIRECT ADVERTISING. IF YOU OBJECT, YOUR PERSONAL
          DATA WILL SUBSEQUENTLY NO LONGER BE USED FOR DIRECT ADVERTISING
          PURPOSES (OBJECTION PURSUANT TO ART. 21(2) GDPR).
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>
          Right to log a complaint with the competent supervisory agency
        </h3>{" "}
        <p>
          In the event of violations of the GDPR, data subjects are entitled to
          log a complaint with a supervisory agency, in particular in the member
          state where they usually maintain their domicile, place of work or at
          the place where the alleged violation occurred. The right to log a
          complaint is in effect regardless of any other administrative or court
          proceedings available as legal recourses.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Right to data portability</h3>{" "}
        <p>
          You have the right to have data that we process automatically on the
          basis of your consent or in fulfillment of a contract handed over to
          you or to a third party in a common, machine-readable format. If you
          should demand the direct transfer of the data to another controller,
          this will be done only if it is technically feasible.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Information about, rectification and eradication of data</h3>{" "}
        <p>
          Within the scope of the applicable statutory provisions, you have the
          right to demand information about your archived personal data, their
          source and recipients as well as the purpose of the processing of your
          data at any time. You may also have a right to have your data
          rectified or eradicated. If you have questions about this subject
          matter or any other questions about personal data, please do not
          hesitate to contact us at any time.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Right to demand processing restrictions</h3>{" "}
        <p>
          You have the right to demand the imposition of restrictions as far as
          the processing of your personal data is concerned. To do so, you may
          contact us at any time. The right to demand restriction of processing
          applies in the following cases:
        </p>{" "}
        <ul>
          {" "}
          <li>
            In the event that you should dispute the correctness of your data
            archived by us, we will usually need some time to verify this claim.
            During the time that this investigation is ongoing, you have the
            right to demand that we restrict the processing of your personal
            data.
          </li>{" "}
          <li>
            If the processing of your personal data was/is conducted in an
            unlawful manner, you have the option to demand the restriction of
            the processing of your data in lieu of demanding the eradication of
            this data.
          </li>{" "}
          <li>
            If we do not need your personal data any longer and you need it to
            exercise, defend or claim legal entitlements, you have the right to
            demand the restriction of the processing of your personal data
            instead of its eradication.
          </li>{" "}
          <li>
            If you have raised an objection pursuant to Art. 21(1) GDPR, your
            rights and our rights will have to be weighed against each other. As
            long as it has not been determined whose interests prevail, you have
            the right to demand a restriction of the processing of your personal
            data.
          </li>{" "}
        </ul>{" "}
        <p>
          If you have restricted the processing of your personal data, these
          data – with the exception of their archiving – may be processed only
          subject to your consent or to claim, exercise or defend legal
          entitlements or to protect the rights of other natural persons or
          legal entities or for important public interest reasons cited by the
          European Union or a member state of the EU.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>SSL and/or TLS encryption</h3>{" "}
        <p>
          For security reasons and to protect the transmission of confidential
          content, such as purchase orders or inquiries you submit to us as the
          website operator, this website uses either an SSL or a TLS encryption
          program. You can recognize an encrypted connection by checking whether
          the address line of the browser switches from “http://” to “https://”
          and also by the appearance of the lock icon in the browser line.
        </p>{" "}
        <p>
          If the SSL or TLS encryption is activated, data you transmit to us
          cannot be read by third parties.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Rejection of unsolicited e-mails</h3>{" "}
        <p>
          We herewith object to the use of contact information published in
          conjunction with the mandatory information to be provided in our Site
          Notice to send us promotional and information material that we have
          not expressly requested. The operators of this website and its pages
          reserve the express right to take legal action in the event of the
          unsolicited sending of promotional information, for instance via SPAM
          messages.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h2 style={{ color: "#ff6600" }}>
          4. Recording of data on this website
        </h2>
        <h3>Cookies</h3>{" "}
        <p>
          Our websites and pages use what the industry refers to as “cookies.”
          Cookies are small data packages that do not cause any damage to your
          device. They are either stored temporarily for the duration of a
          session (session cookies) or they are permanently archived on your
          device (permanent cookies). Session cookies are automatically deleted
          once you terminate your visit. Permanent cookies remain archived on
          your device until you actively delete them, or they are automatically
          eradicated by your web browser.
        </p>{" "}
        <p>
          Cookies can be issued by us (first-party cookies) or by third-party
          companies (so-called third-party cookies). Third-party cookies enable
          the integration of certain services of third-party companies into
          websites (e.g., cookies for handling payment services).
        </p>{" "}
        <p>
          Cookies have a variety of functions. Many cookies are technically
          essential since certain website functions would not work in the
          absence of these cookies (e.g., the shopping cart function or the
          display of videos). Other cookies may be used to analyze user behavior
          or for promotional purposes.
        </p>{" "}
        <p>
          Cookies, which are required for the performance of electronic
          communication transactions, for the provision of certain functions you
          want to use (e.g., for the shopping cart function) or those that are
          necessary for the optimization (required cookies) of the website
          (e.g., cookies that provide measurable insights into the web
          audience), shall be stored on the basis of Art. 6(1)(f) GDPR, unless a
          different legal basis is cited. The operator of the website has a
          legitimate interest in the storage of required cookies to ensure the
          technically error-free and optimized provision of the operator’s
          services. If your consent to the storage of the cookies and similar
          recognition technologies has been requested, the processing occurs
          exclusively on the basis of the consent obtained (Art. 6(1)(a) GDPR
          and § 25 (1) TDDDG); this consent may be revoked at any time.
        </p>{" "}
        <p>
          You have the option to set up your browser in such a manner that you
          will be notified any time cookies are placed and to permit the
          acceptance of cookies only in specific cases. You may also exclude the
          acceptance of cookies in certain cases or in general or activate the
          delete-function for the automatic eradication of cookies when the
          browser closes. If cookies are deactivated, the functions of this
          website may be limited.
        </p>{" "}
        <p>
          Which cookies and services are used on this website can be found in
          this privacy policy.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Server log files</h3>{" "}
        <p>
          The provider of this website and its pages automatically collects and
          stores information in so-called server log files, which your browser
          communicates to us automatically. The information comprises:
        </p>{" "}
        <ul>
          {" "}
          <li>The type and version of browser used</li>{" "}
          <li>The used operating system</li> <li>Referrer URL</li>{" "}
          <li>The hostname of the accessing computer</li>{" "}
          <li>The time of the server inquiry</li> <li>The IP address</li>{" "}
        </ul>{" "}
        <p>This data is not merged with other data sources.</p>{" "}
        <p>
          This data is recorded on the basis of Art. 6(1)(f) GDPR. The operator
          of the website has a legitimate interest in the technically error free
          depiction and the optimization of the operator’s website. In order to
          achieve this, server log files must be recorded.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Contact form</h3>{" "}
        <p>
          If you submit inquiries to us via our contact form, the information
          provided in the contact form as well as any contact information
          provided therein will be stored by us in order to handle your inquiry
          and in the event that we have further questions. We will not share
          this information without your consent.
        </p>{" "}
        <p>
          The processing of these data is based on Art. 6(1)(b) GDPR, if your
          request is related to the execution of a contract or if it is
          necessary to carry out pre-contractual measures. In all other cases
          the processing is based on our legitimate interest in the effective
          processing of the requests addressed to us (Art. 6(1)(f) GDPR) or on
          your agreement (Art. 6(1)(a) GDPR) if this has been requested; the
          consent can be revoked at any time.
        </p>{" "}
        <p>
          The information you have entered into the contact form shall remain
          with us until you ask us to eradicate the data, revoke your consent to
          the archiving of data or if the purpose for which the information is
          being archived no longer exists (e.g., after we have concluded our
          response to your inquiry). This shall be without prejudice to any
          mandatory legal provisions, in particular retention periods.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Request by e-mail, telephone, or fax</h3>{" "}
        <p>
          If you contact us by e-mail, telephone or fax, your request, including
          all resulting personal data (name, request) will be stored and
          processed by us for the purpose of processing your request. We do not
          pass these data on without your consent.
        </p>{" "}
        <p>
          These data are processed on the basis of Art. 6(1)(b) GDPR if your
          inquiry is related to the fulfillment of a contract or is required for
          the performance of pre-contractual measures. In all other cases, the
          data are processed on the basis of our legitimate interest in the
          effective handling of inquiries submitted to us (Art. 6(1)(f) GDPR) or
          on the basis of your consent (Art. 6(1)(a) GDPR) if it has been
          obtained; the consent can be revoked at any time.
        </p>{" "}
        <p>
          The data sent by you to us via contact requests remain with us until
          you request us to delete, revoke your consent to the storage or the
          purpose for the data storage lapses (e.g. after completion of your
          request). Mandatory statutory provisions - in particular statutory
          retention periods - remain unaffected.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h3>Registration on this website</h3>{" "}
        <p>
          You have the option to register on this website to be able to use
          additional website functions. We shall use the data you enter only for
          the purpose of using the respective offer or service you have
          registered for. The required information we request at the time of
          registration must be entered in full. Otherwise, we shall reject the
          registration.
        </p>{" "}
        <p>
          To notify you of any important changes to the scope of our portfolio
          or in the event of technical modifications, we shall use the e-mail
          address provided during the registration process.
        </p>{" "}
        <p>
          We shall process the data entered during the registration process on
          the basis of your consent (Art. 6(1)(a) GDPR).
        </p>{" "}
        <p>
          The data recorded during the registration process shall be stored by
          us as long as you are registered on this website. Subsequently, such
          data shall be deleted. This shall be without prejudice to mandatory
          statutory retention obligations.
        </p>
        <div style={{ margin: "20px" }}></div>
        <h2 style={{ color: "#ff6600" }}>5. Newsletter</h2>
        <h3>Newsletter data</h3>{" "}
        <p>
          If you would like to subscribe to the newsletter offered on this
          website, we will need from you an e-mail address as well as
          information that allow us to verify that you are the owner of the
          e-mail address provided and consent to the receipt of the newsletter.
          No further data shall be collected or shall be collected only on a
          voluntary basis. We shall use such data only for the sending of the
          requested information and shall not share such data with any third
          parties.
        </p>{" "}
        <p>
          The processing of the information entered into the newsletter
          subscription form shall occur exclusively on the basis of your consent
          (Art. 6(1)(a) GDPR). You may revoke the consent you have given to the
          archiving of data, the e-mail address, and the use of this information
          for the sending of the newsletter at any time, for instance by
          clicking on the “Unsubscribe” link in the newsletter. This shall be
          without prejudice to the lawfulness of any data processing
          transactions that have taken place to date.
        </p>{" "}
        <p>
          The data deposited with us for the purpose of subscribing to the
          newsletter will be stored by us until you unsubscribe from the
          newsletter or the newsletter service provider and deleted from the
          newsletter distribution list after you unsubscribe from the newsletter
          or after the purpose has ceased to apply. We reserve the right to
          delete or block e-mail addresses from our newsletter distribution list
          at our own discretion within the scope of our legitimate interest in
          accordance with Art. 6(1)(f) GDPR.
        </p>{" "}
        <p>Data stored for other purposes with us remain unaffected.</p>{" "}
        <p>
          After you unsubscribe from the newsletter distribution list, your
          e-mail address may be stored by us or the newsletter service provider
          in a blacklist, if such action is necessary to prevent future
          mailings. The data from the blacklist is used only for this purpose
          and not merged with other data. This serves both your interest and our
          interest in complying with the legal requirements when sending
          newsletters (legitimate interest within the meaning of Art. 6(1)(f)
          GDPR). The storage in the blacklist is indefinite.{" "}
          <strong>
            You may object to the storage if your interests outweigh our
            legitimate interest.
          </strong>
        </p>
        <div style={{ margin: "20px" }}></div>
        <h2 style={{ color: "#ff6600" }}>
          6. eCommerce and payment service providers
        </h2>
        <h3>Processing of Customer and Contract Data</h3>{" "}
        <p>
          We collect, process, and use personal customer and contract data for
          the establishment, content arrangement and modification of our
          contractual relationships. Data with personal references to the use of
          this website (usage data) will be collected, processed, and used only
          if this is necessary to enable the user to use our services or
          required for billing purposes. The legal basis for these processes is
          Art. 6(1)(b) GDPR.
        </p>{" "}
        <p>
          The collected customer data shall be deleted upon completion of the
          order or termination of the business relationship and upon expiration
          of any existing statutory archiving periods. This shall be without
          prejudice to any statutory archiving periods.
        </p>{" "}
      </div>
    </div>
  );

  return i18n.language.includes("de") ? privacyPolicyDe : privacyPolicyEn;
}

export default PrivacyPolicy;
